/* ==========================================================================
   Giorgio header refresh — moves the account / cart icons out of the header
   row and into the announcement bar above it, on desktop only, wires a proxy
   search button there too.

   Clustering both nav menus beside the left-aligned logo on product pages used
   to live here as well. It was moved into header.liquid: doing it after load
   meant the browser painted the second menu at the far right first and then
   visibly yanked it to the middle. Markup that starts out right cannot jump.

   ACCOUNT + CART: moved for real
   Both identify themselves by id/class, not by position, and nothing in
   Dawn's own JS keys them to a fixed spot in the tree:
     - #cart-icon-bubble is a plain <a>. Cart re-renders find it by id and only
       ever replace its innerHTML, never the node itself, so it keeps working
       wherever it lives.
     - .header__icon--account's own <account-icon> element only adds a
       document-level listener in connectedCallback; that callback fires again
       on a move (a DOM move is spec'd as remove-then-insert), but the listener
       it adds is harmless to duplicate — no user-visible effect.

   SEARCH: forwarded, not moved
   The search trigger opens a full-viewport modal built from
   `position: absolute; inset: 0`, sized against whatever the nearest
   POSITIONED ancestor happens to be — normally the header. This icon cluster
   has to be `position: absolute` itself (to float over the bar without
   disturbing its grid), which means moving the real trigger+modal in here
   would make this tiny cluster the modal's sizing reference instead of the
   page: `position: fixed` escapes that for layout, but the modal's own
   "anchor near the bottom" math — tuned for a header-sized box — then lands
   the search field off-screen against a full-viewport-sized one instead.

   So the real trigger and its modal stay exactly where Dawn put them. The
   proxy button in the bar (rendered by announcement-bar.liquid) only forwards
   its click to that real, hidden trigger.

   Moving happens once per breakpoint crossing, not on every resize event, and
   the exact place each icon came from is marked with a comment node so
   shrinking back to mobile puts everything back where Dawn expects it.
   ========================================================================== */
(function () {
  'use strict';

  var MOVE_SELECTORS = ['.header__icon--account', '#cart-icon-bubble'];
  var mql = window.matchMedia('(min-width: 990px)');
  var moved = false;
  var markers = []; // { node, placeholder }

  function target() {
    return document.getElementById('GioBarIcons');
  }

  function realSearchTrigger() {
    return document.querySelector('.header__search summary.header__icon--search');
  }

  function proxySearchButton() {
    return document.querySelector('.gio-search-proxy');
  }

  function moveIn() {
    var dest = target();
    if (!dest || moved) return;

    markers = [];
    MOVE_SELECTORS.forEach(function (sel) {
      var node = document.querySelector(sel);
      if (!node) return;
      var placeholder = document.createComment('gio-icon-was-here:' + sel);
      node.parentNode.insertBefore(placeholder, node);
      dest.appendChild(node);
      markers.push({ node: node, placeholder: placeholder });
    });
    moved = markers.length > 0;

    var trigger = realSearchTrigger();
    if (trigger) trigger.style.display = 'none';
  }

  function moveOut() {
    if (moved) {
      markers.forEach(function (m) {
        if (m.placeholder.parentNode) {
          m.placeholder.parentNode.insertBefore(m.node, m.placeholder);
          m.placeholder.remove();
        }
      });
      markers = [];
      moved = false;
    }

    var trigger = realSearchTrigger();
    if (trigger) trigger.style.display = '';
  }

  function sync() {
    if (mql.matches) {
      moveIn();
    } else {
      moveOut();
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.gio-search-proxy')) return;
    event.preventDefault();
    var trigger = realSearchTrigger();
    if (trigger) trigger.click();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  if (mql.addEventListener) {
    mql.addEventListener('change', sync);
  } else if (mql.addListener) {
    // Safari < 14.
    mql.addListener(sync);
  }

})();
